<script setup lang="ts"></script>

<template>
  <div class="relative flex justify-center items-center">
    <div class="absolute animate-spin rounded-full h-32 w-32 border-t-8 border-x-4 border-b-4 border-logo-font-color"></div>
    <div class="rounded-full overflow-hidden h-32 w-32 bg-navy">
      <img src="/logos/galvanick-yellow.svg" class="rounded-full h-32 w-32 scale-[130%] origin-center animate-logo-pulse" alt="Galvanick logo"/>
    </div>
  </div>
</template>

<style scoped>
@keyframes logoPulse {
  0% {
    margin: 0;
  }
  25% {
    margin-bottom: 5px;
    margin-left: 10px;
  }
  50% {
    margin: 0;
  }
  75% {
    margin-top: 0;
    margin-right: 10px;
  }
  100% {
    margin: 0;
  }
}

.animate-logo-pulse {
  scale: 110%;
  animation: logoPulse 3s infinite ease-in-out;
}
</style>
